module.exports = __webpack_public_path__ + "img/money_icon.202e33b9.svg";